export default __webpack_public_path__ + "static/media/car-front.bc8206a9.jpg";